<template>
  <div class="tip-page-box" :style="color != 'text' && color != 'grey-text'  ? `background: ${backgroundColor};` : 'padding-left: 0'">
    <div class="left-tip-icon-box" v-if="color != 'text' && color != 'grey-text'">
      <div class="left-tip">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/bule.png" alt="" v-if="color == 'bule'">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/gley.png" alt="" v-else-if="color == 'gley' || color == 'none'">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/yello.png" alt="" v-else-if="color == 'yello'">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/red.png" alt="" v-else-if="color == 'red'">
      </div>
    </div>
    <div class="right-tip-box" :style="color == 'text' && color == 'grey-text' ? `color: ${backgroundColor};` : ''">
      <slot>{{ text }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "JDTipBox",
  props: {
    color: {
      type: String,
      // 支持蓝色bule、灰色gley、黄色yello、红色red
      default: 'bule',
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    backgroundColor(){
      switch(this.color){
        case 'bule':
          return '#EBF3FF';
        case 'gley':
          return '#F4F4F5';
        case 'yello':
          return '#FFFBE6';
        case 'red':
          return '#FFF1F0';
        case 'none':
          return 'none';
        case "text":
          return "#ff9245";
        case "grey-text":
          return "#666666";
        default: 
          return '#EBF3FF';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-page-box {
  width: 100%;
  padding: 9px 14px;
  border-radius: 2px;
  .left-tip-icon-box {
    width: 16.25px;
    height: 22px;
    margin-right: 10px;
    float: left;
    display: flex;
    justify-items: center;
    align-items: center;
    .left-tip {
      width: 16.25px;
      height: 16.25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .right-tip-box {
    display: inline-block;
    width: calc(100% - 30px);
    color: #666666;
    font-size: 12px;
    line-height: 22px;
  }
}
</style>